<div 
    @fade
    [class]="ClassList ? ClassList : ''"
    class="overlay_container custom_scroll md"
>
    <ng-content select="*"></ng-content>
</div>